<template>
  <div class="bc-white  padding-20" >
    <b class="fs-18">培训视频库</b>
    <div class="display-flex jc-space-between ai-center">
      <el-form :inline="true" size="small" v-model="searchForm" class="mt-20">
        <el-form-item label="">
          <el-input
            placeholder="输入视频名称搜索"
            clearable
            v-model="searchForm.fuzzy"
          ></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="getTableData" size="small"> 查询</el-button>
        </el-form-item>
      </el-form>
      <el-button  size="small" type="primary" icon="el-icon-plus" @click="add">添加</el-button>
    </div>
    <div class="listBox">
      <div class="itemBox" v-for="item in tableData" :key="item.id">
        <div class="width-percent-100 height-140 bc-black" :style="{background: `url(${item.coverPicUrl})`, backgroundSize: 'cover'}"></div>
        <!-- <video class="width-percent-100 height-140" :poster="item.coverPicUrl"></video> -->
        <img alt="" class="playImg" src="@/assets/images/play.png"  @click="play(item)">
        <div class="padding-16" style="box-sizing: border-box;border-top: 1px solid #D9D9D9">
          <div class="text-ellipsis width-200">{{item.name}}</div>
          <div class="display-flex jc-space-between ai-center mt-14">
            <div style="height: 12px;border-radius: 12px;background: #F6F6F6;padding: 6px 12px;display: flex;align-items: center">
              <img alt="" src="@/assets/images/time.png" style="width: 12px;height: 12px;margin-right: 6px;" >
              <span class="color-info fs-12">时长：{{item.duration | duration}}</span>
            </div>
            <div>
              <i @click="edit(item)" class="cursor-pointer ml-10 fs-18 el-icon-edit-outline color-primary"></i>
              <i @click="del(item)" class="cursor-pointer ml-10 fs-18 el-icon-delete color-danger"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="display-flex fd-row-reverse mt-20">
      <!-- 表格数据的分页的功能 -->
      <el-pagination
        hide-on-single-page
        @current-change="(val) => {searchForm.pageNum = val}"
        :current-page="searchForm.pageNum"
        :page-size="searchForm.pageSize"
        background
        layout="total, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog
      v-if="addDialog.show"
      :title="addDialog.title"
      :visible.sync="addDialog.show"
      append-to-body
      width="490px">
      <el-form
        class="diy-top-form"
        :model="addDialog.form"
        ref="ruleForm"
        label-position="top"
        size="small">
        <el-form-item>
          <div class='upload-box'>
            <el-upload
              :show-file-list="false"
              accept=".mp4"
              class="ava-uploader"
              :http-request="uploadFile"
              :before-upload="beforeUploadVideo"
              action=''>
              <div class='info-content display-flex fd-column jc-center ai-center'>
                <img src='@/assets/images/add.png' style="width: 28px; height: 28px;"/>
                <span class='fs-14 fw-bold'>将文件拖到此处，或点击上传</span>
              </div>
            </el-upload>
          </div>
          <div v-if="addDialog.form.fileList.length" class="br-4 mt-10 padding-10 pl-20 pr-20" style="background-color:#F5F5F5;">
            <div class="display-flex ai-center jc-space-between">
              <div class="display-flex ai-center">
                <img class="width-20 mr-10" src='@/assets/images/mp4.png'/>
                <span>{{ addDialog.form.fileList[0].name }}</span>
              </div>
              <i class="fs-18 el-icon-delete color-danger cursor-pointer" @click="addDialog.form.fileList = []"></i>
            </div>
<!--            <el-progress class="mt-10 display-flex ai-center jc-space-between" v-if="percentage||uploadLoading" :percentage="percentage"></el-progress>-->
          </div>
        </el-form-item>
        <el-form-item label='视频名称' prop="name" :rules="{required: true, message: '请输入视频名称', trigger: 'blur'}">
          <el-input
            placeholder="不输入则使用视频文件名作为视频名称"
            clearable
            v-model="addDialog.form.name"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
            <el-button size="small" type="primary" @click="submit" :loading="uploadLoading">确 定</el-button>
            <el-button size="small" @click="addDialog.show = false">取 消</el-button>
          </span>
    </el-dialog>
    <el-dialog
      v-if="videoDialog.show"
      title="视频预览"
      width="760px"
      :visible.sync="videoDialog.show">
      <div id="video" style="width: 720px;height: 360px"></div>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash';
export default {
  name: 'Index',
  components: { },
  props: {

  },
  data () {
    return {
      videoDialog: {
        show: false,
        url: ''
      },
      baseUrl: process.env.VUE_APP_BASE_API,
      index: 0,
      totalChunks: 0,
      chunkList: [],
      uploadId: '',
      submitData: {},
      searchForm: {
        fuzzy: '',
        pageNum: 1,
        pageSize: 10
      },
      uploadLoading: false,
      addDialog: {
        title: '',
        show: false,
        form: {
          id: '',
          fileList: [],
          name: '',
          duration: '',
          filename: '',
          fileSize: '',
          videoId: ''
        }
      },
      tableData: [],
      total: 0,
      player: null
    }
  },
  filters: {
    duration (val) {
      let h = parseInt(val / 60 / 60 % 24)
      h = h < 10 ? '0' + h : h
      let m = parseInt(val / 60 % 60)
      m = m < 10 ? '0' + m : m
      let s = parseInt(val % 60)
      s = s < 10 ? '0' + s : s
      // 作为返回值返回
      return `${h}:${m}:${s}`
    }
  },
  computed: {
    _searchForm () {
      return JSON.parse(JSON.stringify(this.searchForm))
    },
    percentage () {
      if (this.totalChunks) {
        return Math.floor((this.index / this.totalChunks) * 100) || 0
      } else {
        return 0
      }
    }
  },
  watch: {
    _searchForm: {
      handler: function (newVal, oldVal) {
        if (newVal.pageNum !== 1 && newVal.pageNum === oldVal.pageNum) {
          this.searchForm.pageNum = 1;
        } else {
          this.getTableData()
        }
      },
      deep: true
    }
  },
  methods: {
    loadVideo () {
      this.$nextTick(() => {
        // eslint-disable-next-line no-undef,no-unused-vars
        this.player = new Aliplayer({
          id: 'video',
          source: this.videoDialog.url,
          width: '100%',
          height: '100%',
          autoplay: true,
          isLive: false
        })
      })
    },
    play (item) {
      this.$api.video.play({ id: item.videoId }).then(res => {
        this.videoDialog.url = res
        this.videoDialog.show = true
        this.loadVideo()
      })
    },
    edit (item) {
      this.totalChunks = 0
      this.index = 0
      this.chunkList = []
      this.uploadId = item.id
      this.addDialog.title = '编辑'
      this.addDialog.form = {
        id: item.id,
        fileList: [
          {
            name: item.name
          }
        ],
        name: item.name,
        duration: item.duration,
        filename: item.filename,
        fileSize: item.fileSize,
        videoId: item.videoId
      }
      this.addDialog.show = true
    },
    del (item) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.video.del({ id: item.id }).then(res => {
          this.$message.success('删除成功')
          this.searchForm.pageNum = 1
          this.getTableData()
        })
      }).catch(() => {});
    },
    // 视频上传前执行
    beforeUploadVideo (file) {
      if (!['video/mp4'].includes(file.type)) {
        this.$message.warning('请上传正确的视频格式');
        return false;
      }
      const fileSize = file.size / 1024 / 1024 < 1024; // 控制大小  修改50的值即可
      if (!fileSize) {
        this.$message.warning('视频大小不能超过1GB');
        return false;
      }
    },
    uploadFile (e) {
      this.uploadLoading = true
      this.addDialog.form.fileList = [e.file]
      this.addDialog.form.name = this.addDialog.form.name || e.file.name
      const fileurl = URL.createObjectURL(e.file);
      const audioElement = new Audio(fileurl);
      audioElement.addEventListener('loadedmetadata', (_event) => {
        this.addDialog.form.duration = Number(parseInt(audioElement.duration))
        this.addDialog.form.filename = e.file.name
        this.addDialog.form.fileSize = e.file.size
        const formData = new FormData()
        formData.append('file', this.addDialog.form.fileList[0])
        formData.append('duration', this.addDialog.form.duration)
        this.$api.video.upload(formData).then(res => {
          this.addDialog.form.videoId = res.aliyunVideoId
          this.uploadLoading = false
        }).catch(() => {
          this.uploadLoading = false
          this.addDialog.form.fileList = []
        })
      });
    },
    /**
     * 新增视频
     */
    add () {
      this.totalChunks = 0
      this.index = 0
      this.uploadId = ''
      this.chunkList = []
      this.addDialog.title = '新增'
      this.addDialog.form = {
        id: '',
        fileList: [],
        name: '',
        duration: '',
        filename: '',
        fileSize: '',
        videoId: ''
      }
      this.addDialog.show = true
    },
    submit () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.uploadLoading = true
          if (this.addDialog.form.id) {
            this.$api.video.edit(this.addDialog.form).then(res => {
              this.uploadLoading = false
              this.$message.success('操作成功')
              this.addDialog.show = false
              this.getTableData()
            }).catch(() => {
              this.uploadLoading = false
            })
          } else {
            this.$api.video.add(this.addDialog.form).then(res => {
              this.uploadLoading = false
              this.$message.success('操作成功')
              this.addDialog.show = false
              this.getTableData()
            }).catch(() => {
              this.uploadLoading = false
            })
          }
        }
      })
    },
    // 文件切片
    chunk () {
      // 获取文件并转成 ArrayBuffer 对象
      const fileObj = this.addDialog.form.fileList[0]
      // 将文件按固定大小（10M）进行切片
      const chunkSize = 1024 * 1024 * 10;
      const chunkList = []; // 保存所有切片的数组
      const chunkListLength = Math.ceil(fileObj.size / chunkSize); // 计算总共多个切片
      let curChunk = 0 // 切片时的初始位置
      for (let i = 0; i < chunkListLength; i++) {
        const item = {
          index: i,
          chunk: fileObj.slice(curChunk, curChunk + chunkSize)
        }
        curChunk += chunkSize
        chunkList.push(item)
      }
      this.totalChunks = chunkListLength
      this.chunkList = chunkList // sendRequest 要用到
      this.sendRequest()
    },
    // 发送请求
    sendRequest () {
      if (this.index) {
        this.chunkList = this.chunkList.filter(item => item.index > this.index)
      }
      const fn = (item) => {
        return new Promise((resolve, reject) => {
          const formData = new FormData()
          formData.append('file', item.chunk)
          formData.append('chunkNum', item.index)
          formData.append('fileSize', this.addDialog.form.fileList[0].size)
          formData.append('fileName', this.addDialog.form.name)
          formData.append('id', this.uploadId)
          formData.append('name', this.addDialog.form.name)
          this.$api.video.edit(formData).then(res => {
            this.index = item.index
            if ((this.index + 1) === this.totalChunks) {
              this.$message.success('上传完成')
              this.index++
              this.uploadLoading = false
              this.addDialog.show = false
              this.searchForm.pageNum = 1
              this.getTableData()
            }
            resolve(res)
          }).catch(err => {
            this.uploadLoading = false
            reject(err)
          })
        })
      }
      const forOf = async () => {
        for (const item of this.chunkList) {
          await fn(item)
        }
      }
      forOf()
    },
    getTableData: _.debounce(function () {
      const data = {
        fuzzy: this.searchForm.fuzzy,
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize
      }
      this.$api.video.list(data).then(res => {
        this.tableData = res.list
        this.total = res.total
      })
    }, 500)

  },
  beforeCreate () {
  },
  created () {
    const oScript = document.createElement('script');
    oScript.type = 'text/javascript';
    oScript.src = 'https://g.alicdn.com/de/prismplayer/2.15.6/aliplayer-min.js';
    document.body.appendChild(oScript);
    const oScript2 = document.createElement('script');
    oScript2.type = 'text/javascript';
    oScript2.src = '/aliplayercomponents-1.0.9.min.js';
    document.body.appendChild(oScript2);
    const oLink = document.createElement('link');
    oLink.rel = 'stylesheet';
    oLink.href = 'https://g.alicdn.com/de/prismplayer/2.15.6/skins/default/aliplayer-min.css';
    document.body.appendChild(oLink);
  },
  beforeMount () {
  },
  mounted () {
    this.getTableData()
  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
  },
  destroyed () {
  }
}
</script>

<style lang="scss" scoped>
.listBox{
  display: flex;
  flex-wrap: wrap;
  .itemBox{
    width: calc(20% - 18px);
    margin-right: 20px;
    margin-bottom: 20px;
    position: relative;
    border-radius:4px;
    border: 1px solid #D9D9D9;
    &:nth-child(5n) {
      margin-right: 0;
    }
    .playImg{
      position: absolute;
      cursor: pointer;
      content: '';
      width: 60px;
      height: 60px;
      z-index: 2;
      display: flex;
      left: calc(50% - 30px);
      top:42px;
    }
  }
}
.upload-box {
  padding: 16px 18px;
  background-color: #F5F5F5;
  border: 1px dashed #d9d9d9;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  border-radius: 6px;
  box-sizing: border-box;
  .ava-uploader {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    color: #999;
    background-color: #fff;
    .info-content {
      font-size: 28px;
      color: #8c939d;
      width: 398px;
      height: 144px;
      text-align: center;
    }
  }
}
.upload-box:hover {
  border-color: #f58ea8;
}

.avatar-uploader-icon {
  border: 1px dashed #d9d9d9 !important;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px !important;
  position: relative !important;
  overflow: hidden !important;
}

.avatar-uploader .el-upload:hover {
  border: 1px dashed #d9d9d9 !important;
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 300px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 300px;
  height: 178px;
  display: block;
}

::v-deep
.vjs-big-play-button{
  position: absolute;
  content: '';
  top:calc(50% - 44px) ;
  left: calc(50% - 20px);
}
</style>
